import { module } from 'modujs';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        this.swiper = null;
        this.slides = this.el.querySelectorAll('.swiper-slide');
        this.labelButtons = Array.from(this.el.querySelectorAll('[data-tabs-label]'));
        this.contents = this.el.querySelector('.c-tabs_contents');
        this.navigation = this.labelButtons.length ? 'labels' : 'pagination';
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    init() {
        this.el.style.setProperty('--tabs-autoplay-progress', this.prefersReducedMotion ? 1 : 0);

        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: true,
            loop: this.slides.length > 1,
            speed: this.prefersReducedMotion ? 0 : 700,
            grabCursor: this.slides.length > 1,
            watchOverflow: true,
            autoplay: this.navigation === 'pagination' && this.slides.length > 1 && !this.prefersReducedMotion ? {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false,
            pagination: this.navigation === 'pagination' ? {
                el: this.el.querySelector('.c-tabs_pagination'),
                clickable: true,
            } : false,
            breakpoints: {
                700: {
                    spaceBetween: 20,
                },
            },
            on: {
                slideChange: () => {
                    this.el.style.setProperty('--tabs-autoplay-progress', 0);
                    this.updateLabels();
                },
                autoplayTimeLeft: (swiper, time, progress) => {
                    this.el.style.setProperty('--tabs-autoplay-progress', 1 - progress);
                },
            },
            modules: [Autoplay, Pagination],
        });

        this.labelButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.swiper.slideToLoop(Number(button.dataset.index));
            });
        });

        this.contents?.addEventListener('click', (event) => this.navigateFromSide(event));
    }

    updateLabels() {
        const activeIndex = this.swiper?.realIndex ?? 0;

        this.labelButtons.forEach((button, index) => {
            const isActive = index === activeIndex;
            button.classList.toggle('-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    }

    navigateFromSide(event) {
        if (event.target.closest('a, button, input, select, textarea, video, audio')) {
            return;
        }

        const activeSlide = this.el.querySelector('.swiper-slide-active');
        if (!activeSlide || this.slides.length < 2) {
            return;
        }

        const midpoint = activeSlide.getBoundingClientRect().left + activeSlide.getBoundingClientRect().width / 2;
        if (event.clientX < midpoint) {
            this.swiper.slidePrev();
        } else {
            this.swiper.slideNext();
        }
    }

    destroy() {
        this.swiper?.destroy(true, true);
    }
}
